import React from 'react';
import LogoSvg from './cdom-logo.svg';
import * as Styled from './cdom-logo.styles';

interface ILogoProps extends Partial<Pick<HTMLImageElement, 'height' | 'width'>> {}

export const CdomLogo = (props: ILogoProps) => {
  return <Styled.ImageContained src={LogoSvg} alt="MyMedicalMap" {...props} />;
};
